import classNames from "classnames"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import Header from "../Header"
import SideBar from "../SideBar"
import style from "./style.scss"

interface DrawerProps {
  id?: string
  title: string
}

const Drawer: React.SFC<Readonly<DrawerProps>> = (props) => {
  const [sideBarOpen, setSideBarOpen] = useState(false)

  const handleSideBarClose = () => {
    setSideBarOpen(false)
  }

  const handleSideBarOpen = () => {
    setSideBarOpen(true)
  }

  useEffect(() => {
    const handleCloseOnOutsideClick = (event: any) => {
      const isChildOfSidebar = event.target.closest(`.${style.sideBar}`)

      if (isChildOfSidebar) {
        return
      }

      if (sideBarOpen) {
        handleSideBarClose()
      }
    }

    document.addEventListener("click", handleCloseOnOutsideClick)

    return () => {
      document.removeEventListener("click", handleCloseOnOutsideClick)
    }
  })

  return (
    <div
      id={props.id}
      className={classNames(style.drawer, {
        [style["drawer--open"]]: sideBarOpen
      })}
    >
      <SideBar
        className={style.sideBar}
        open={sideBarOpen}
        onClose={handleSideBarClose}
      />
      <main className={style.page}>
        <Header
          title={props.title}
          sidebarToggle={sideBarOpen ? handleSideBarClose : handleSideBarOpen}
        />
        <div className={style.content}>{props.children}</div>
      </main>
    </div>
  )
}

export default connect(
  null,
  null
)(Drawer)
